module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#video-play",
      toString: function () {
        return this.url;
      }
    }